import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

const ORANGE = "#f47420"
const BLUE = "#0d6efd"
const PURPLE = "#6f42c1"
const GREEN = "#198754"
const GRID = "rgba(0, 0, 0, 0.06)"
const TICK = "rgba(0, 0, 0, 0.42)"

export default class extends Controller {
  static targets = ["canvas", "seriesButton"]
  static values = {
    data: Object,
    turnoverLabel: String,
    servicesLabel: String,
    partsLabel: String,
    paymentsLabel: String
  }

  connect() {
    this.activeSeries = "turnover"
    const dataset = this.datasetFor(this.activeSeries)

    this.chart = new Chart(this.canvasTarget, {
      type: "bar",
      data: {
        labels: this.dataValue.labels,
        datasets: [dataset]
      },
      options: this.chartOptions()
    })
  }

  selectSeries(event) {
    event.preventDefault()
    this.activeSeries = event.currentTarget.dataset.series
    const dataset = this.datasetFor(this.activeSeries)

    this.chart.data.datasets[0] = dataset
    this.seriesButtonTargets.forEach((button) => {
      const active = button.dataset.series === this.activeSeries
      button.classList.toggle("active", active)
      button.setAttribute("aria-pressed", String(active))
    })
    this.chart.update()
  }

  changeMonth(event) {
    event.currentTarget.form?.requestSubmit()
  }

  datasetFor(series) {
    const config = {
      turnover: { label: this.turnoverLabelValue, color: ORANGE, background: "rgba(244, 116, 32, 0.14)" },
      services: { label: this.servicesLabelValue, color: BLUE, background: "rgba(13, 110, 253, 0.14)" },
      parts: { label: this.partsLabelValue, color: PURPLE, background: "rgba(111, 66, 193, 0.14)" },
      payments: { label: this.paymentsLabelValue, color: GREEN, background: "rgba(25, 135, 84, 0.16)" }
    }[series]

    return {
      label: config.label,
      data: this.dataValue[series].map(Number),
      backgroundColor: config.background,
      borderColor: config.color,
      borderWidth: 1.5,
      borderRadius: 4,
      borderSkipped: false
    }
  }

  chartOptions() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      animation: { duration: 300 },
      plugins: {
        legend: { display: false },
        tooltip: {
          backgroundColor: "rgba(255, 255, 255, 0.98)",
          borderColor: "rgba(0, 0, 0, 0.12)",
          borderWidth: 1,
          titleColor: "rgba(0, 0, 0, 0.5)",
          bodyColor: "rgba(0, 0, 0, 0.8)",
          padding: 10,
          callbacks: {
            label: (ctx) => `${ctx.dataset.label}: €${Number(ctx.raw).toFixed(2)}`
          }
        }
      },
      scales: {
        x: {
          grid: { display: false },
          border: { color: GRID },
          ticks: { color: TICK, font: { size: 11 } }
        },
        y: {
          grid: { color: GRID },
          border: { color: "transparent" },
          ticks: {
            color: TICK,
            font: { size: 11 },
            callback: (val) => `€${val}`
          }
        }
      }
    }
  }

  disconnect() {
    this.chart?.destroy()
    this.chart = null
  }
}
